import { useEffect, useRef } from 'react'

export function usePrevious<T>(value: T): T | undefined
export function usePrevious<T>(value: T, defaultValue: T): T
/**
 * Caches the passed in value and return the previous cached value. Returns
 * undefined on first call.
 */
export function usePrevious<T>(value: T, defaultValue?: T): T | undefined {
  const ref = useRef<T>(undefined)

  useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current ?? defaultValue
}
